import PropTypes from 'prop-types';
import { useEffect } from 'react';

import { useFormAsFormikApi } from '../../useFormAsFormikApi';

const FormStateHandler = ({ setFormikState }) => {
  const formProps = useFormAsFormikApi();

  useEffect(() => {
    setFormikState?.(formProps);
  }, [formProps, setFormikState]);
};

export default FormStateHandler;

FormStateHandler.propTypes = {
  /**
   * Callback for updating formik state
   */
  setFormikState: PropTypes.func,
};
